import React from 'react';
import { BrainIcon, LayersIcon, RefreshCwIcon, RouteIcon } from 'lucide-react';
import { differentiators } from '../data/content';
const ICONS = [BrainIcon, RouteIcon, LayersIcon, RefreshCwIcon];
export function NotAnEbook() {
  return <section className="w-full bg-slate-950 px-5 py-12 text-white sm:py-16" data-id="element-109" data-mp="3vet4emeqfobo">
      <div className="mx-auto max-w-[960px] text-center" data-id="element-110" data-mp="3qg9iun41weju">
        <h2 className="text-balance text-[1.5rem] font-extrabold uppercase leading-[0.95] tracking-tight sm:text-[1.9rem]" data-id="element-111" data-mp="3mfpkxhbnl6wn">
          This isn't just another Anatomy & Physiology ebook
        </h2>
        <p className="mt-2 text-balance text-[1.25rem] font-extrabold uppercase leading-[0.95] tracking-tight text-orange-500 sm:text-[1.6rem]" data-id="element-112" data-mp="3chjkl45hw8tw">
          It's a ready-to-use visual teaching system.
        </p>

        <dl className="mx-auto mt-9 grid max-w-[820px] gap-x-10 gap-y-6 text-left sm:grid-cols-2" data-id="element-113" data-mp="1apwrmx21m3us">
          {differentiators.map((item, index) => {
          const Icon = ICONS[index % ICONS.length];
          return <div key={item.title} className="flex items-start gap-3" data-id="element-114" data-mp="3n2fff4luhif7" data-mpi={index}>
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-orange-500" aria-hidden="true" data-id="element-115" data-mp="3s3361p65vx8w" />
                <div data-id="element-116" data-mp="3d6ud15cv6g4x">
                  <dt className="text-[1rem] font-extrabold uppercase leading-tight tracking-tight text-white" data-id="element-117" data-mp="3d7nj044011m0">
                    {item.title}
                  </dt>
                  <dd className="mt-1 text-[0.93rem] leading-relaxed text-white/80" data-id="element-118" data-mp="9p2o5zu0ycay">
                    {item.description}
                  </dd>
                </div>
              </div>;
        })}
        </dl>

        <p className="mt-9 text-balance text-[1rem] font-extrabold uppercase leading-tight tracking-tight text-white sm:text-[1.15rem]" data-id="element-119" data-mp="3w22jxz9vf4ch">
          Less searching. Less preparing. More teaching clarity.
        </p>
      </div>
    </section>;
}